module.exports = __webpack_public_path__ + "static/img/spotify_sm.1de11e8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/spotify_sm.svg
// module id = tu2d
// module chunks = 1